module.exports = __webpack_public_path__ + "static/media/resear-step-1.0cf863e6.png";